<template>
  <div style="height: 100%; background: #F2F2F6">
         <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">{{$t("base.index")}}</el-breadcrumb-item>
          <el-breadcrumb-item>产品管理</el-breadcrumb-item>
          <el-breadcrumb-item>年龄分类</el-breadcrumb-item>
        </el-breadcrumb>

  <el-row style="margin-top:10px">

       <el-col :span="23" style="text-align:right">
        <el-button size="small" type="primary" @click="searchAge()">{{$t("base.search")}}</el-button>
        <el-button  :title="$t('base.new')" style="background:linear-gradient(to bottom,rgb(90, 157, 171),#0093a8);color:#ffffff" size="small" icon="el-icon-plus" @click="showAge()"></el-button>
      </el-col>
  </el-row>
   <el-divider></el-divider>
        <el-table
          :data="tabledata"
          ref="table"
          stripe
          border
          style="margin:0 30px;width: calc(100% - 60px);border-radius: 0.625rem;font-size:12px"
           :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'line-height': '20px', padding: '8px', 'text-align': 'center' }"
        >
          <el-table-column
            type="index"
            label=""
            width="75"
            :index="indexMethod"
          ></el-table-column>
          <el-table-column prop="name" label="名称">
          </el-table-column>
           <el-table-column prop="pic" label="图片">
            <template slot-scope="scope">
               <el-image
    style="width: 40px; height: 40px"
    :src="scope.row.pic" >
  </el-image>
            </template>
           </el-table-column>
          <el-table-column prop="sort" label="排序">
            </el-table-column>
          <el-table-column :label="$t('base.opt')" column-key="opt" width="300">
            <template  slot-scope="scope"   >
              <el-button
              v-if="user.isadmin||($store.state.permission.CreateVersion&&$store.state.permission.CreateVersion.show)"
                size="mini"
                type="text"
                @click="showAge(scope.row)"
                >{{$t("base.edit")}}</el-button
              >
               <el-divider v-if="user.isadmin||($store.state.permission.CreateVersion&&$store.state.permission.CreateVersion.show)"   direction="vertical"></el-divider>
              <el-button
              v-if="user.isadmin||($store.state.permission.CreateVersion&&$store.state.permission.CreateVersion.show)"
              size="mini"
                type="text"
                @click="handleDelete(scope.row)"
                >{{$t("base.del")}}</el-button
              >
            </template>
          </el-table-column>
        </el-table>

    <el-row style="height:40px">
        <el-pagination
          background
          :page-sizes="[10, 15, 30, 50]"
          :current-page="pageset.index"
          :page-size="pageset.size"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total,sizes,prev, pager, next"
          :total="totalsize"
          style="float: right; margin-top: 0.625rem;margin-bottom:10px"
        >
        </el-pagination>
    </el-row>
        <el-dialog title="年龄段" :close-on-click-modal="false" :visible.sync="dialogFormVisible">
  <el-form
          :model="age"
          :rules="rules"
          ref="customerForm"
          label-width="150px"
          label-position="right"
          size="mini"
        >
        <el-form-item label="名称" prop="name">
            <el-input v-model="age.name" maxlength="20"></el-input>
          </el-form-item>

          <el-form-item label="排序" prop="sort">
              <el-input v-model="age.sort" maxlength="3" type="number" ></el-input>
          </el-form-item>
           <el-form-item label="图片" prop="pic">
             <el-upload
            style="text-align:left"
              class="avatar-uploader"
              name="upload"
              action="http://resource.ddyuewu.com/resource/upload?isauth=0&type=2&program_type=BASE&filename="
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload">
              <el-image  v-if="age.pic" :src="age.pic" class="avatar"></el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <el-button  v-if="age.pic" type="text" @click="age.pic=''">删除图片</el-button>
        </el-form-item>
        </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button @click="dialogFormVisible = false">取 消</el-button>
    <el-button type="primary" @click="saveAge()">确 定</el-button>
  </div>
</el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'RoleList',
  data () {
    return {
      user: {},
      age: {
      },
      tabledata: [],
      pageset: {
        size: 10,
        index: 1
      },
      totalsize: 0,
      where: {
        category: 'age'
      },
      dialogFormVisible: false,
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
      }
    }
  },
  mounted: function () {
    var self = this
    let user = window.localStorage.getItem('customer')
    if (user) {
      this.user = JSON.parse(user)
      self.searchAge()
    } else {
      this.$message({
        message: this.$t('base.noSession'),
        type: 'warning'
      })
      self.$router.push({ name: 'Login' })
    }
  },
  methods: {
    handleAvatarSuccess (response) {
      this.age.pic = response.url
      this.$forceUpdate()
    },
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    showAge (row) {
      if (row) {
        this.age = Object.assign({}, row)
      } else {
        this.age = {sort: 0, pic: null}
      }
      this.dialogFormVisible = true
    },

    saveAge () {
      this.$refs.customerForm.validate((valid) => {
        if (valid) {
          let url = '/product/params/add'
          if (this.age.innerid) {
            url = '/product/params/edit'
          } else {
            this.age.category = 'age'
          }
          Vue.axios
            .post(url, this.age)
            .then((res) => {
              if (res.data.errcode === 0) {
                this.$message({
                  showClose: true,
                  message: this.$t('base.saveSuccess'),
                  type: 'success'
                })
                this.searchAge()
                this.dialogFormVisible = false
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.errmsg || this.$t('base.systemError'),
                  type: 'error'
                })
              }
            })
        } else {
          return false
        }
      })
    },

    searchAge () {
      var self = this
      Vue.axios
        .post('/product/params/list', {
          where: self.where,
          pageset: self.pageset
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.tabledata = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t('base.systemError'),
              type: 'error'
            })
          }
        })
      Vue.axios
        .post('/product/params/list/count', {
          where: self.where
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.totalsize = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t('base.systemError'),
              type: 'error'
            })
          }
        })
    },
    indexMethod (index) {
      return (this.pageset.index - 1) * this.pageset.size + index + 1
    },
    handleSizeChange (val) {
      this.pageset.size = val
      this.searchAge()
    },
    handleCurrentChange (val) {
      this.pageset.index = val
      this.searchAge()
    },
    handleDelete (row) {
      this.$confirm(
        '确认删除' + row.name + '？',
        this.$t('base.info'),
        {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          var self = this
          Vue.axios
            .post('/product/params/del', {
              innerid: row.innerid
            })
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  type: 'success',
                  message: self.$t('base.delSuccess')
                })
                self.searchAge()
              } else {
                self.$message({
                  showClose: true,
                  message:
                    res.data.errmsg || this.$t('base.systemError'),
                  type: 'error'
                })
              }
            })
        })
        .catch(() => {})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/ProductParams/Age.vue